/* 🤖 this file was generated by script */
export const wiconReceipt = {
  name: 'receipt',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 7.8c0-1.68 0-2.52.33-3.16a3 3 0 011.3-1.31C6.29 3 7.13 3 8.8 3h6.4c1.68 0 2.52 0 3.16.33a3 3 0 011.31 1.3c.33.65.33 1.49.33 3.17V21l-2.75-2-2.5 2L12 19l-2.75 2-2.5-2L4 21V7.8z"/></svg>`,
};
